<template>
    <Dialog :header="HeaderContent" v-model:visible="Editmodel" :breakpoints="{ '960px': '40vw','641px': '60vw','500px': '80vw' }"
        :style="{ width: '30vw' }" :modal="true" :closable="false">
        <p>{{ content }}</p>
        <template #footer>
            <AddButton :btnname="$t('btn.yes')" @click="$emit('yes')" />
            <AddButton :btnname="$t('btn.no')" @click="$emit('no')" />
        </template>
    </Dialog>
</template>
<script lang="ts">

import { defineComponent, ref } from 'vue'

export default defineComponent({

    props: {

        Editmodel: {
            readonly: false,
            type: Boolean,
            default: ref(false),
        },
        content: {
            type: String
        },
        HeaderContent:{
            type: String,
            default:'Confirm Edit!'
        }

    },
    setup() {

        return {
        }
    },


    methods: {

    }
})

</script>